<template>
  <div class="btn-group">
    <button type="button"
            @click="selected = 'grid'"
            class="btn btn-outline btn-primary px-2 py-1"
            :class="{ 'btn-primary': selected === 'grid', 'btn-light': selected !== 'grid' }">
      <i class="fas fa-th-large tw-w-4 tw-h-4"></i>
    </button>
    <button type="button"
            @click="selected = 'masonry'"
            class="btn btn-outline px-2 py-1"
            :class="{ 'btn-primary': selected === 'masonry', 'btn-light': selected !== 'masonry' }">
      <img class="tw-w-4 tw-h-4" :src="selected === 'masonry' ? masonryWhiteUrl : masonryUrl" alt="Masonry" />
    </button>
  </div>
</template>

<script>
import AssetLoader from "../../../AssetLoader";

export default {
  props: [
    'value'
  ],
  computed: {
    masonryUrl() {
      return AssetLoader.imagePath('ic-masonry.svg');
    },

    masonryWhiteUrl() {
      return AssetLoader.imagePath('ic-masonry-white.svg');
    },

    selected: {
      get() { return this.value },
      set(val) { this.$emit('input', val)}
    }
  }
}
</script>